<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row>
      <v-col cols="12">
        <p class="font-weight-bold gray--text quotation-title mb-7">
          SEGURADO
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-12">
      <v-col cols="12" sm="6" class="pr-0 pr-sm-5">
        <BaseFormSelect
          id-element="typeInsuredQuotation"
          placeholder="Selecione"
          v-model="formInsured.tipo_pessoa"
          :items="listType"
          required
          :rules="[requiredInput]"
          label-text="Tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" class="pr-0">
        <DocumentInput
          id-element="cpfCnpjInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.numero_documento"
          validate-on-blur
          :rules="validTypeDocumentAccordingOptionsQuotation"
          label-text="CPF/CNPJ"
          document-type="hybrid"
        />
      </v-col>
      <v-col cols="12" class="pr-0">
        <BaseFormAutocomplete
          id-element="nameInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.nome"
          required
          :items="insuredByNameOrCPFCNPJ"
          :rules="[requiredInput, isValidName]"
          label-text="Nome"
          hide-no-data
          @keyup="searchInput"
          item-text="nome"
          :return-object="false"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
        <BaseFormInput
          id-element="cepInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.cep"
          :rules="validCEPAccordingOptionsQuotation"
          validate-on-blur
          v-facade="maskCEP"
          label-text="CEP"
        />
      </v-col>
      <v-col cols="12" sm="6" md="10" class="pr-0">
        <BaseFormInput
          id-element="addressInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.logradouro"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Endereço"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
        <BaseFormInput
          id-element="numberInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.numero"
          :rules="validNumberAccordingOptionsQuotation"
          label-text="Número"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="10" class="pr-0">
        <BaseFormInput
          id-element="complementInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.complemento"
          label-text="Complemento"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
        <BaseFormSelect
          id-element="ufInsuredQuotation"
          placeholder="Selecione"
          v-model="formInsured.endereco.uf"
          :items="brazilianStates"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="UF"
          item-text="nome"
          item-value="sigla"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
        <BaseFormInput
          id-element="cityInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.cidade"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Cidade"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormInput
          id-element="neighborhoodInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.endereco.bairro"
          :rules="validAddressAccordingOptionsQuotation"
          label-text="Bairro"
        />
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import {
  requiredInput,
  isValidCpfOrCnpj,
  isValidCep,
  maxLengthNumber,
  documentNumberMatchesType
} from "@/utils/rules.js";
import { maskCEP } from "@/utils/masks.js";
import { brazilianStates } from "@/utils/utils.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import { formatCpfOrCnpf } from "@/utils/formats";
import DocumentInput from "@/components/form/DocumentInput.vue";
import _ from "lodash";
const nameRegex = /^[A-zÀ-ÿ'-]+\s([A-zÀ-ÿ'-]\s?)*[A-zÀ-ÿ']+$/;
const listType = [
  {
    id: "pessoa_fisica",
    nome: "PESSOA FÍSICA"
  },
  {
    id: "pessoa_juridica",
    nome: "PESSOA JURÍDICA"
  }
];
export default {
  data: () => ({
    formValid: true,
    loading: false,
    listType: listType,
    requiredInput,
    isValidCpfOrCnpj,
    maskCEP,
    brazilianStates,
    searchName: null,
    searchCPFCNPJ: null,
    timeout: null,
    isValidCep,
    maxLengthNumber,
    formatCpfOrCnpf
  }),
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["insuredByNameOrCPFCNPJ"]),
    formInsured: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    ruleSameType() {
      return documentNumberMatchesType(
        this.formInsured.tipo_pessoa?.id,
        this.formInsured.numero_documento
      );
    },
    isValidName() {
      return (
        (this.formInsured.tipo_pessoa &&
          this.formInsured.tipo_pessoa.id == "pessoa_juridica") ||
        (this.formInsured.tipo_pessoa &&
          this.formInsured.tipo_pessoa.id == "pessoa_fisica" &&
          (nameRegex.test(this.formInsured.nome) ||
            nameRegex.test(this.formInsured.nome?.nome))) ||
        "Nome de segurado deve ter nome e sobrenome válidos"
      );
    },
    validTypeDocumentAccordingOptionsQuotation() {
      return this.optionsQuotation.segurado[this.formInsured.tipo_pessoa?.id]
        ?.documento.obrigatorio
        ? [this.requiredInput, this.isValidCpfOrCnpj, this.ruleSameType]
        : [];
    },
    validAddressAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput] : [];
    },
    validCEPAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.isValidCep] : [];
    },
    validNumberAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.maxLengthNumber] : [];
    },
    validAdress() {
      return this.optionsQuotation.segurado[this.formInsured.tipo_pessoa?.id]
        ?.endereco.obrigatorio;
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  components: { DocumentInput },
  methods: {
    ...mapActions("quotation", ["requestInsuredByNameOrCPFCNPJ"]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    cancelQuotation() {
      this.$emit("cancel");
    },
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      if ((value?.target?.value || "").length >= 3) {
        this.timeout = setTimeout(function() {
          vm.fetchInsured(value);
          vm.timeout = null;
        }, 1000);
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Verificar se o elemento escolhido tem os mesmos valores da tabela conforme
        // o id, se não tiver, devo deixar null o id
        const item = this.insuredByNameOrCPFCNPJ.find(
          x => x.id == this.value.id
        );
        this.value.id = item?.nome == this.value.nome ? this.value.id : null;
        this.$emit("submit", this.value);
      }
    },
    async fetchInsured(value) {
      const queryValue = value.target.value;
      const payload = {
        query: queryValue,
        tipoPessoa: this.formInsured.tipo_pessoa
      };
      // Não sei porque ele perde o valor, então devo guardar ele
      this.formInsured.numero_documento =
        value.target.id === "cpfCnpjInsuredQuotation"
          ? queryValue
          : this.formInsured.numero_documento;
      await this.withLoading(this.requestInsuredByNameOrCPFCNPJ(payload));
      document.getElementById(value.target.id).focus();
      const type =
        value.target.id == "cpfCnpjInsuredQuotation"
          ? "numero_documento"
          : "nome";

      this.autocompleteFormAccordingInput(payload.query, type);
    },
    autocompleteFormAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      const item = this.insuredByNameOrCPFCNPJ.find(x => x[input] == value);
      if (item) {
        this.formInsured = this.mergeProperties(
          _.cloneDeep(item),
          this.formInsured
        );
        this.formInsured.numero_documento = this.formatCpfOrCnpf(
          item.numero_documento
        );
        // mergeProperties não resolve para objetos com valores nulos
        // forcarei o merge aqui, e quando resolver o problema
        // na funcao mergeProperties eu deleto essa parte
        this.formInsured.tipo_pessoa = _.cloneDeep(item.tipo_pessoa);
        this.formInsured.endereco.uf = _.cloneDeep(item.endereco.uf);
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  },
  watch: {
    "formInsured.numero_documento"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "numero_documento";
      this.autocompleteFormAccordingInput(item, type);
    },
    "formInsured.nome"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "nome";
      this.autocompleteFormAccordingInput(item, type);
    }
  }
};
</script>

